import * as types from 'constants/ActionTypes';
import { Map } from 'immutable';

const defaultState = Map({
  user: null,
  isUserLoading: false,
  isUserFetched: false,
  nextPurchase: null,
  isNextPurchaseLoading: false,
  isNextPurchaseFetched: false,
  connectedAccounts: [],
  isConnectedAccountsLoading: false,
  isConnectedAccountsFetched: false,
  wallets: [],
  isWalletsLoading: false,
  isWalletsFetched: false,
  showDotersUnavailableDialog: false,
});

/**
 * Reducer for Reserhub account state
 * @param {Object} state - Current state
 * @param {Object} action - Action to process
 * @returns {Object} New state
 */
export default function reserhubAccount(state = defaultState, action) {
  switch (action.type) {
    case types.SET_RESERHUB_USER_LOADING:
      return action.isLoading
        ? state.set('isUserLoading', true)
        : state.set('isUserLoading', false).set('isUserFetched', true);
    case types.SET_RESERHUB_USER:
      return state.set('user', action.user).set('isUserLoading', false).set('isUserFetched', true);
    case types.CLEAR_RESERHUB_USER:
      return state.set('user', null).set('isUserLoading', false).set('isUserFetched', true);
    case types.SET_RESERHUB_NEXT_PURCHASE_LOADING:
      return state
        .set('isNextPurchaseLoading', action.isLoading)
        .set('isNextPurchaseFetched', !action.isLoading);
    case types.SET_RESERHUB_NEXT_PURCHASE:
      return state
        .set('nextPurchase', action.nextPurchase)
        .set('isNextPurchaseLoading', false)
        .set('isNextPurchaseFetched', true);
    case types.CLEAR_RESERHUB_NEXT_PURCHASE:
      return state
        .set('nextPurchase', null)
        .set('isNextPurchaseLoading', false)
        .set('isNextPurchaseFetched', true);
    case types.SET_RESERHUB_CONNECTED_ACCOUNTS_LOADING:
      return action.isLoading
        ? state.set('isConnectedAccountsLoading', true)
        : state.set('isConnectedAccountsLoading', false).set('isConnectedAccountsFetched', true);
    case types.SET_RESERHUB_CONNECTED_ACCOUNTS:
      return state
        .set('connectedAccounts', action.connectedAccounts)
        .set('isConnectedAccountsLoading', false)
        .set('isConnectedAccountsFetched', true);
    case types.SET_RESERHUB_WALLETS_LOADING:
      return state
        .set('isWalletsLoading', action.isLoading)
        .set('isWalletsFetched', !action.isLoading);
    case types.SET_RESERHUB_WALLETS:
      return state
        .set('wallets', action.wallets)
        .set('isWalletsLoading', false)
        .set('isWalletsFetched', true);
    case types.SET_RESERHUB_DOTERS_UNAVAILABLE_DIALOG_VISIBLE:
      return state.set('showDotersUnavailableDialog', action.visible);
    default:
      return state;
  }
}
